import { DOCUMENT_TYPE_DNI, DOCUMENT_TYPE_RUC } from "../consts/listDocumentType";

export const formatDocument = (documentType, documentNumber) => {
    switch (documentType) {
        case DOCUMENT_TYPE_DNI.value:
            return documentNumber.replace(/[^0-9]/g, '');
        case DOCUMENT_TYPE_RUC.value:
            return documentNumber.replace(/[^0-9]/g, '');
        default:
            return documentNumber.replace(/[^A-Za-z0-9-.]/g, '');
    }
}
